var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"alert alert-warning\">\n<h3 class=\"text-warning\">\n<i class=\"fa fa-lock\" aria-hidden=\"true\"></i>\nPermission denied\n</h3>\n<p>\nYou don&rsquo;t have the permission to access this feature. Please contact the customer success team.\n</p>\n</div>\n";
var id1="app/_directives/pkp-permission-denied.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;